/** 舊的 i18n code 或其他可能的語系格式 需 308 轉址 */
const redirect308Mapping = {
  zh: 'zh-tw',
  tw: 'zh-tw',
  cn: 'zh-cn',
  jp: 'ja',
}

export default defineNuxtPlugin(nuxtApp => {
  const { vueApp, $i18n } = nuxtApp
  const req = useRequestURL()
  const route = useRoute()
  const [_, prefix = ''] = route.path.split('/')

  // onBeforeLanguageSwitch 觸發於 locale 值變更之前
  // 當新的 locale 值不是可使的語系時，可以給予原本的 locale 阻止變更
  // vueApp.$i18n.onBeforeLanguageSwitch = (oldLocale, newLocale) => {

  // }

  nuxtApp.hook('i18n:beforeLocaleSwitch', ({ oldLocale, newLocale, initialSetup, context }) => {
    const availableLocales = $i18n.locales.value.filter(i => i.code !== $i18n.locale.value).map(i => i.code)
    // console.log('onBeforeLanguageSwitch', oldLocale, newLocale)
    const isNewLocaleSupported = availableLocales.includes(newLocale)
    return isNewLocaleSupported ? newLocale : oldLocale
  })

  // called right after a new locale has been set
  // onLanguageSwitched 觸發於 locale 值變更完成
  // nuxtApp.hook('i18n:localeSwitched', ({ oldLocale, newLocale }) => {
  //   // console.log('onLanguageSwitched', oldLocale, newLocale)
  //   // setLanguageCookie(newLocale)
  // })

  // /**
  //  * 設定 cookie `language`：這個 cookie 用於舊 FunNow Web 的多語系
  //  * 設定 cookie `language-nuxt`：
  //  * 這個 cookie 用於 FunNow Web Nuxt 的多語，原本是由 nuxtI18n 的 options.detectBrowserLanguage 設定自動寫入，因客製化規則改由手動寫入
  //  * @param {string} locale
  //  */
  // function setLanguageCookie(locale) {
  //   const oneYear = 60 * 60 * 24 * 365
  //   const localeObj = $i18n.locales.value.find(localeObj => localeObj.code === locale)
  //   if (!localeObj) {
  //     return
  //   }
  //   nuxtApp.$cookiz.set('language', localeObj.name, { path: '/', maxAge: oneYear })
  //   nuxtApp.$cookiz.set('language-nuxt', locale, { path: '/', maxAge: oneYear })
  // }

  // /**
  //  * 有帶語系 prefix 的網址
  //  * 管 cookie 或瀏覽器語系為何，都顯示該 prefix 的語言
  //  * ex: /ja/* 就是顯示日文
  //  * 若使用者直接輸入網址或是點其他連結，開啟了有帶語系的網址，**不會**記錄/覆寫 cookie 中的語系偏好
  //  */
  // if (vueApp.$i18n.availableLocales.includes(prefix)) {
  //   return
  // }

  // /**
  //  * 語系調整
  //  * 原 cn -> zh-cn
  //  * 原 jp -> ja
  //  * 若是原本的路徑，則要 308 轉導至新的路徑
  //  */
  // const redirectLocale = redirect308Mapping[prefix.toLocaleLowerCase()]
  // if (redirectLocale) {
  //   navigateTo(308, route.fullPath.replace(prefix, redirectLocale))
  //   return
  // }

  // /**
  //  * 沒有 prefix | 對不上 availableLocales | 對不上 redirect308Mapping
  //  * 依此順序處理（包含爬蟲）：
  //  * 1. 檢查 Cookie 內是否有使用者選擇過的語系，若有，則 302 導向該語言的網址
  //  * 2. 偵測瀏覽器語系，若有且符合可使用的語系，則 302 導向該語言的網址
  //  * 3. 若都無符合的（例如瀏覽器預設為泰文），預設顯示英文
  //  */
  // const cookieLocale = vueApp.$cookiz.get('language-nuxt') || ''
  // const browserLocale = vueApp.$i18n.getBrowserLocale()
  // const host = process.server ? req.headers.host : window.location.host
  // const isBookingEngineSubdomainHost = checkBookingEngineSubdomainHost(host)

  // /**
  //  * 若為 subdomain (ex: woorao.myfunnow.com) 且無語系 Path, 要忽視 cookie
  //  * 並且清除掉 cookie
  //  */
  // if (isBookingEngineSubdomainHost) {
  //   vueApp.$cookiz.remove('language')
  //   vueApp.$cookiz.remove('language-nuxt')
  // } else {
  //   /**
  //    * Cookie 中如果是舊的 locale code
  //    * 改寫為新的 locale code + 302 轉導
  //    */
  //   const redirectOldCookieLocale = redirect308Mapping[cookieLocale.toLocaleLowerCase()]
  //   if (redirectOldCookieLocale) {
  //     setLanguageCookie(redirectOldCookieLocale, vueApp)
  //     navigateTo(302, vueApp.localePath(route, redirectOldCookieLocale))
  //     return
  //   }

  //   if (cookieLocale && vueApp.$i18n.availableLocales.includes(cookieLocale)) {
  //     navigateTo(302, vueApp.localePath(route, cookieLocale))
  //     return
  //   }
  // }

  // if (browserLocale && vueApp.$i18n.availableLocales.includes(browserLocale)) {
  //   navigateTo(302, vueApp.localePath(route, browserLocale))
  //   return
  // }

  // navigateTo(302, vueApp.localePath(route, vueApp.$i18n.fallbackLocale))
})
